export const dateFormat = 'DD/MM/YYYY';
export const timeFormat = 'h:mmA';
export const datetimeFormat = 'DD/MM/YYYY, h:mmA';
export const yearMonthDateFormat = 'YYYY-MM-DD';
